export default {
    data() {
        return {
            windowHeight: window.innerHeight
        }
    },
    computed: {
        dynamicHeight() {
            // 可根据需求调整偏移量
            const offset = document.getElementById('header') ? document.getElementById('header').offsetHeight+100 : 250  // 顶部导航栏等固定元素高度
            return `${this.windowHeight - offset}px`
        }
    },
    mounted() {
        // 使用防抖处理resize事件，避免频繁触发导致ResizeObserver错误
        this.debouncedHandleResize = this.debounce(this.handleResize, 100);
        window.addEventListener('resize', this.debouncedHandleResize)
    },
    unmounted() {
        window.removeEventListener('resize', this.debouncedHandleResize)
    },
    methods: {
        handleResize() {
            this.windowHeight = window.innerHeight
        },
        // 防抖函数
        debounce(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }
    }
}
